<template>
    <div>
        <v-tabs
            class="fusedship-tab"
            background-color="white"
            v-model="tab"
            color="dark"
            show-arrows="mobile"
        >
            <v-tab href="#to-machship">
                Field Mapper
            </v-tab>
            <v-tab href="#value-lookups">
                Value Lookups
            </v-tab>
            <v-tab href="#status-mapper">
                Status Mapper
            </v-tab>
            <v-tab href="#company-location">
                Company & Location Mapper
            </v-tab>
            <v-tab href="#carrier-services">
                Carriers & Service Mapper
            </v-tab>
            <v-tab href="#packing-rules">
                Packing Rules
            </v-tab>
            <v-tab href="#liverate-settings">
                Live Rate Settings
            </v-tab>
            <v-tab href="#ms-err-actions">
                Machship Error Actions
            </v-tab>
            <v-tab v-if="isWebhookPlatform" href="#webhooks">
                Webhooks
            </v-tab>
            <v-tab v-if="adminOnly" href="#error-handler">
                Integration Errors
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" class="fusedship-tab-items" touchless>
            <v-tab-item value="to-machship">
                <p v-if="!showMappers"
                    class="d-flex justify-center pa-5 pt-16">
                    <v-btn @click="onShowMappers"
                        outlined>
                        Show Mapper
                    </v-btn>
                </p>


                <v-tabs
                    v-if="showMappers"
                    background-color="dark"
                    color="dark"
                    show-arrows="mobile"
                    v-model="activeFieldMapperTab">
                    <v-tab href="#tab-field-mapper">Field Mapper</v-tab>
                    <v-tab href="#tab-consignment-product-mapper">Consignment - Product Mapper</v-tab>
                    <v-tab href="#tab-liverate-product-mapper">Live Rate - Product Mapper</v-tab>
                    <v-tab-item value="tab-field-mapper">
                        <IntegrationsMappingForm
                        :id="integrationId"
                        :direction="'to_machship'"
                        :is_view="is_view" />
                    </v-tab-item>
                    <v-tab-item value="tab-consignment-product-mapper">
                        <FormProductMapper
                            ref="tab-consignment-mapper"
                            :is_view="is_view"
                            :id="integrationId"
                            direction="consignment"
                            :productMappings="consignmentProductMapping"
                            :defaultMappings="consignmentDefaultProductMapping"
                        />
                    </v-tab-item>
                    <v-tab-item value="tab-liverate-product-mapper">
                        <FormProductMapper
                            ref="tab-liverate-mapper"
                            :is_view="is_view"
                            :id="integrationId"
                            direction="liverate"
                            :productMappings="liverateProductMapping"
                            :defaultMappings="liverateDefaultProductMapping"
                        />
                    </v-tab-item>
                </v-tabs>



            </v-tab-item>

            <v-tab-item value="company-location">
                <CompanyLocation :id="integrationId" :metas="metas" />
            </v-tab-item>

            <v-tab-item value="carrier-services">
                <CarrierServices :id="integrationId" :metas="metas" />
            </v-tab-item>

            <v-tab-item value="packing-rules">
                <PackingRules :id="integrationId" class="px-5" />
            </v-tab-item>

            <v-tab-item value="liverate-settings">
                <LiverateSettings :id="integrationId" />
            </v-tab-item>

            <v-tab-item value="value-lookups">
                <IntegrationsValueLookupsForm
                    :id="integrationId"
                    :direction="'to_machship'"
                    :is_view="is_view" />
            </v-tab-item>

            <v-tab-item value="status-mapper">
                <StatusMapping
                    :id="integrationId"
                    :is_view="is_view" />
            </v-tab-item>

            <v-tab-item value="ms-err-actions">
                <MSErrorActions :id="integrationId" />
            </v-tab-item>

            <v-tab-item value="webhooks">
                <Webhooks
                    :id="integrationId"
                    :type="webhookType"
                />
            </v-tab-item>

            <v-tab-item value="error-handler">
                <ErrorHandler
                    :id="integrationId"
                    :metas="metas"
                />
            </v-tab-item>

        </v-tabs-items>
    </div>
</template>

<script>
import { EventBus } from '@/js/event-bus.js'
import IntegrationsMappingForm from './forms/IntegrationsMappingForm'
import IntegrationsValueLookupsForm from './forms/IntegrationsValueLookupsForm'
import StatusMapping from '../tabs/StatusMapping'
import ProductMapper from './tabs/product-mapper/ProductMapperStruct'
import {
    CompanyLocation,
    CarrierServices,
    LiverateSettings,
    MSErrorActions,
    Webhooks,
    ErrorHandler,
    FormProductMapper,
    PackingRules

} from './tabs';

export default {

    props: {
        is_view: { type: Boolean, default: false },
        integration: { type: Object, default: () => null }
    },

    components: {
        IntegrationsMappingForm,
        IntegrationsValueLookupsForm,
        StatusMapping,
        CompanyLocation,
        CarrierServices,
        PackingRules,
        LiverateSettings,
        MSErrorActions,
        Webhooks,
        ErrorHandler,
        FormProductMapper
    },

    data() {
        return {
            tab: 'to-machship',
            integrationId: null,
            isAdmin: false,
            showMappers: false,
            activeFieldMapperTab: 'tab-field-mapper',

            // Integration type IDs that support webhooks
            webhookSupportedIntegrationTypes: [12, 44, 30, 5, 26], // Shopify, Shopify Updates Only, BigCommerce, DEAR Systems, Unleashed

            consignmentDefaultProductMapping: {},
            consignmentProductMapping: {},

            liverateDefaultProductMapping: {},
            liverateProductMapping: {}
        }
    },

    computed: {
        isIntegrationNotPending() {
            return this.integration && this.integration.master_consignment_type != 'PENDING'
        },

        isWebhookPlatform() {
            return this.integration && this.webhookSupportedIntegrationTypes.includes(this.integration.integration_type_id)
        },

        adminOnly() {
            return this.$store.getters.isAdmin
        }

    },

    created() {
        this.integrationId = parseInt(this.$route.params.id)
        this.webhookType = this.integration.integration_type.display_name
        this.metas = this.integration.metas

    },

    methods: {

        onShowMappers() {
            this.onGetProductMappings()
            this.showMappers = true
        },

        onGetProductMappings() {

            this.$http
                .get(`/api/fieldmappers/product-mapping/${this.integrationId}`)
                .then(({ data }) => {

                    this.consignmentDefaultProductMapping = data.default.consignment ?? {}
                    this.liverateDefaultProductMapping = data.default.liverate || {}

                    const integrationMapping = data.integration
                    integrationMapping.forEach(mapping => {
                        if(mapping.data_direction == 'consignment') {
                            this.consignmentProductMapping[mapping.machship_field] = this.addNewProductMapping(mapping)
                        } else {
                            this.liverateProductMapping[mapping.machship_field] = this.addNewProductMapping(mapping)
                        }
                    });
                })
                .catch(err => {
                    EventBus.$emit('show-error', err)
                })
                .finally(() => {
                    this.isLoading = false
                })
        },

        addNewProductMapping(mapping) {
            return new ProductMapper({
                key: mapping.machship_field || '',
                dataSource: mapping.map_type || '',
                dataSourceValue: mapping.source_field || '',
                castAs: mapping.data_conversion_type || '',
                castAsValue: mapping.data_conversion_value || ''
            })
        }
    }

}
</script>
